import { useState } from 'react';

export default function useModal(): { modalIsVisible: boolean; toggleModal: () => void; showModal: () => void; closeModal: () => void } {
  const [modalIsVisible, setModalIsVisible] = useState(false);

  const toggleModal = () => {
    setModalIsVisible(prevState => !prevState);
  };

  const showModal = () => {
    setModalIsVisible(true);
  };

  const closeModal = () => {
    setModalIsVisible(false);
  };

  return {
    modalIsVisible,
    toggleModal,
    showModal,
    closeModal,
  };
}
